import { FC } from "react";
import styled from "@emotion/styled";

const GrowWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  height: "100%",
  flexGrow: 1,
}));

export const Grow: FC = () => <GrowWrapper />;
